/**
 * Pure dictation-text helpers. Chrome's Web Speech API emits inconsistent
 * whitespace and non-breaking spaces between final transcript chunks; these
 * normalize and join chunks so dictation reads naturally.
 */

/** Replace non-breaking spaces with regular spaces. */
export const normalizeSpeech = (s: string): string => (s ?? '').replace(/\u00A0/g, ' ');

/** Trim leading inline whitespace (spaces/tabs) but keep leading newlines. */
export const trimStartInline = (s: string): string => s.replace(/^[^\S\r\n]+/, '');

/** Trim trailing inline whitespace (spaces/tabs) but keep trailing newlines. */
export const trimEndInline = (s: string): string => s.replace(/[^\S\r\n]+$/, '');

/**
 * Append a freshly dictated chunk to the existing input, inserting a single
 * space between words but NOT before punctuation or across an existing
 * newline boundary.
 */
export const appendDictation = (prevRaw: string, nextRaw: string): string => {
  const prev = String(prevRaw ?? '');
  let next = normalizeSpeech(String(nextRaw ?? ''));
  if (!next) return prev;
  const left = trimEndInline(prev);
  next = trimStartInline(next);
  if (!left) return next;
  if (/\r?\n$/.test(left) || /^\r?\n/.test(next)) return left + next;
  if (/^[,.;:!?)]/.test(next)) return left + next;
  return left + ' ' + next;
};
